import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Actions
import { setAlert } from '../../actions/alertActions';
  
const TriggerAlerts = ({
    setAlert
}) =>  {

    // -- Trigger Alerts on page load --

    useEffect(() => {
        // Logic now runs once after the component mounts
        const alert_type = localStorage.getItem("trigger_alert");

        if (alert_type) {

            // After posting on mobile user is redirect to home page. Show this success alert 
            if (alert_type === "post_success") {
                setAlert("Posted! Your post was sent.", "okay");
            }
            localStorage.removeItem("trigger_alert");
        }
    }, [setAlert]); // Dependency array ensures this runs once

    return null;
}
  
TriggerAlerts.propTypes = {
    setAlert: PropTypes.func.isRequired,
}

export default connect(null, { 

    // Connecting actions to the component
    setAlert
})(TriggerAlerts);
  